import {DmsRequest} from "../common/dms-request";
import {FunctionalHeader} from "../common/functional-header";
import {TechnicalHeaderInRequest} from "../common/technical-header-in-request";
import {UserInformation} from "../common/user-information";
import {GetPriceAndStockInformationRequestBody} from "./get-price-and-stock-information-request-body";

export class GetPriceAndStockInformationRequest implements DmsRequest {
  simpleName: string = "price-stock";
  functionalHeader: FunctionalHeader;
  technicalHeader: TechnicalHeaderInRequest;
  userInformation: UserInformation;
  body: GetPriceAndStockInformationRequestBody;
}
